import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { NotificationListsFilterFormValues, NotificationsListsFilterFormField } from 'features/notification/components/type';
import { useGetDropDownData } from 'features/notification/use-cases/get-common-api-data';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';


const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
  formId: string;
  handleFilter: (values: NotificationListsFilterFormValues) => void;
  initialValues: NotificationListsFilterFormValues;
  closeModal?: () => void;
};

export const NotificationsListsFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: UsersFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<NotificationListsFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const [categorySearchKey, setCategorySearchKey] = useState("");
  //const [eventSearchKey, setEventSearchKey] = useState("");

  const { data:deliveryType } = useGetDropDownData({
          flag: "deliverytype",
          searchId:0,
          SearchKey: ""
          },{
    refetchOnWindowFocus: false,
     refetchOnMount: false, staleTime: 1000 * 60 * 5 });


    const { data: eventList } = useGetDropDownData({
    flag: "events",
    searchId: 0,
    SearchKey:'' //eventSearchKey
    },
    {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: 1000 * 60 * 5 // ✅ cache for 5 min
  }
  // {
  //   enabled: !!eventSearchKey && eventSearchKey?.trim().length > 0  // API will run only when value exists
  // }
);

   const { data: categoryList, isLoading: categoryLoading,isFetching:categoryIsFetching } = useGetDropDownData({
    flag: "eventcategory",
    searchId: 0,
    SearchKey: categorySearchKey
    },{
    enabled: !!categorySearchKey && categorySearchKey?.trim().length > 0  // API will run only when value exists
  });

  const onReset = () => {
    form.resetFields();
    handleFilter(initialValues);
  };

  const onFinish = (formValues: NotificationListsFilterFormValues) => {

    const payload = {
    ...formValues,
   
    EventId: formValues.EventId?.join(","),
    TicketCategoryId:formValues.TicketCategoryId?.join(","),
   
   };

    handleFilter(payload);
    closeModal?.();
  };

   // const isSearchEnabledEvent = !!eventSearchKey?.trim();
  //const event_loading = isSearchEnabledEvent && (eventLoading || eventFetching);

  const isSearchEnabledCategory = !!categorySearchKey && categorySearchKey?.trim().length > 0;
  const category_loading = isSearchEnabledCategory && (categoryLoading || categoryIsFetching);

  return (
    
    <Form<NotificationListsFilterFormValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper style={{width:'100%'}}>
        <StandardItemsWrapper style={{width:'100%'}}>
          {/* <div className='invoice_list' style={{width:'100%'}}> */}

          


          <Form.Item<NotificationListsFilterFormValues>
            label={'Notification Template'}
            name={NotificationsListsFilterFormField.TEMPLATE}
          >
            <Input
              placeholder={'Search'}
            />
          </Form.Item>
          <Form.Item<NotificationListsFilterFormValues>
            label={'Notification Title'}
            name={NotificationsListsFilterFormField.TITLE}
          >
            <Input
              placeholder={'Search'}
            />
          </Form.Item>
              <Form.Item<NotificationListsFilterFormValues>
            label={'Event'}
            name={NotificationsListsFilterFormField.EVENTID}
          >
            <Select
              mode="multiple"
              style={{ width: "350px" }}
              showSearch
              // loading={event_loading}
              placeholder="Select Event Name"
              className='cstm_select'

              options={eventList?.notificationDropDownList?.map((res: any) => ({
                label: res.title,
                value: res.id,
              }))}

              // ✅ Enable search by BOTH label + value
              filterOption={(input, option) => {
                const label = option?.label?.toString().toLowerCase() || "";
                const value = option?.value?.toString().toLowerCase() || "";

                return (
                  label.includes(input.toLowerCase()) ||
                  value.includes(input.toLowerCase())
                );
              }}

              onChange={(values: number[]) => {
                const searchKey = values.join(",");
                setCategorySearchKey(searchKey);
              }}

              maxTagCount={2}
              maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
            />
          </Form.Item>
               <Form.Item<NotificationListsFilterFormValues>
            label={'Event Category'}
            name={NotificationsListsFilterFormField.CATEGORYID}
          >
               <Select
                                         mode="multiple"
                                           style={{ width: "200px" }}
                                        showSearch
                                          loading={category_loading}
                                        options={categoryList?.notificationDropDownList?.map((res: any) => ({
                                        label: res.title,
                                        value: res.id
                                        }))}
                                       // disabled={selected== 'All' }
                                        placeholder={"Select Category"}
                                        // filterOption={(input, option) =>
                                        //     (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        // }

                                    />
          </Form.Item>
                 <Form.Item<NotificationListsFilterFormValues>
            label={'Delivery Type'}
            name={NotificationsListsFilterFormField.DELIVERYTYPE}
          >
            <Select                                              
                  placeholder="Please select"
                  style={{ width: "100%" }}
                  options={deliveryType?.notificationDropDownList?.map((res: any) => ({
                      label: res.title,
                      value: res.id
                  }))}
                   
                      />
          </Form.Item>
          {screens.lg && (
        <ContentFilters.ButtonsWrapper >
          <Button type='primary' htmlType='submit'>
            {t('common.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>  
    </Form>
  );
};
